import { useMutation, useQueryClient } from 'react-query';
import FeatureFlagsApi from '../FeatureFlagsApi';
import { CreateFeatureFlagInput, FeatureFlag } from '../types';
import { evaluatedFeatureFlagsQueryKey } from '../../../shared/featureFlags/useEvaluatedFeatureFlagsQuery';
import { featureFlagsQueryKey } from './queryKeys';

export function useCreateFeatureFlagMutation() {
    const queryClient = useQueryClient();

    return useMutation<FeatureFlag, unknown, CreateFeatureFlagInput>(
        (input) => FeatureFlagsApi.create(input),
        {
            onSuccess: () => {
                queryClient.invalidateQueries([featureFlagsQueryKey]);
                queryClient.invalidateQueries([evaluatedFeatureFlagsQueryKey]);
            }
        }
    );
}
